import jquery from 'jquery';
window.jQuery = window.$ = jquery;
